<template>
  <div class="layout layout--default layout--padd">
    <Header />
    <div class="u-width-wrapper">
      <div class="main-content">
        <SideBlock region="content_above" />
        <NuxtPage keepalive />
        <SideBlock region="content_below" />
      </div>
      <Sidebar />
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
  definePageMeta({
    middleware: ["common-data"]
  });
</script>

<style scoped lang="scss">
  .u-width-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }
</style>
